/** Variable (and choice-group) keys: snake_case, starting with a letter. */
export const KEY_RE = /^[a-z][a-z0-9_]*$/;
export const KEY_RULE_MESSAGE = 'key must be snake_case: start with a letter; lowercase letters, digits, underscores';
/** A `#rrggbb` colour. */
export const HEX_RE = /^#[0-9a-fA-F]{6}$/;
/** Signing/presentation order of a document within an envelope. */
export const SIGNING_ORDER_MIN = 1;
export const SIGNING_ORDER_MAX = 99;
//# sourceMappingURL=validation.js.map